// Set release name using app version if available, otherwise use EVA@{environment} pattern
// Fall back to REACT_APP_ENV if REACT_APP_SENTRY_ENVIRONMENT is not set.
// Lives in its own module so both sentry.ts and crashDetector.ts can import it
// without creating an import cycle.
export function getSentryRelease(): string {
  const environmentForRelease =
    process.env.REACT_APP_SENTRY_ENVIRONMENT ||
    process.env.REACT_APP_ENV ||
    "development";
  return `EVA@${process.env.REACT_APP_SENTRY_RELEASE || environmentForRelease}`;
}
